import client from "services/client";

export const get = async (preferenceTag) => {
  return await client
    .get(`/preferences/${preferenceTag}`)
    .catch((error) => error);
};

export default { get };
